var _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 164,
    viewBox: "0 0 177 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.218 28.4684C155.082 31.8729 156.266 36.5785 155.762 42.3643C155.258 48.1584 153.065 54.9211 149.322 62.2344C141.837 76.8554 128.294 93.4067 110.429 108.358C92.5641 123.309 73.8697 133.738 58.1336 138.55C50.2625 140.958 43.2044 141.937 37.3958 141.426C31.5956 140.916 27.1549 138.936 24.2907 135.532C21.4265 132.127 20.2427 127.422 20.7463 121.636C21.2507 115.842 23.4433 109.079 27.1867 101.766C34.6708 87.1447 48.2147 70.5934 66.0794 55.6422C83.9442 40.6911 102.639 30.2618 118.375 25.4496C126.246 23.0425 133.304 22.0632 139.112 22.574C144.913 23.084 149.353 25.0638 152.218 28.4684Z",
    stroke: "white",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88,
    cy: 124.947,
    rx: 6,
    ry: 5.98434,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartButtonIcon);
export default __webpack_public_path__ + "static/media/start-button-icon.30441cceb1cb5b73742b53dacf38d180.svg";
export { ForwardRef as ReactComponent };